import { render, staticRenderFns } from "./DonutTableGraph.vue?vue&type=template&id=6b38f5a8&"
import script from "./DonutTableGraph.vue?vue&type=script&lang=js&"
export * from "./DonutTableGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports